"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../../../assets/constants/constants");
const VisualCheckbox_1 = __importDefault(require("../../../../../components/visualCheckbox/VisualCheckbox"));
const data_repository_1 = require("../../../../../dataSource/data_repository");
const AmenitiesStyles_1 = require("./AmenitiesStyles");
const Amenities = ({ name, roomId, withHeader = true }) => {
    const [amenities, setAmenities] = (0, react_1.useState)({});
    const [installations, setInstallations] = (0, react_1.useState)({});
    const mountAmenitites = (0, react_1.useCallback)((features) => {
        const amenitiesList = [
            { key: 'wifi', value: 'WIFI' },
            { key: 'airConditioning', value: 'AIR_CONDITIONING' },
            { key: 'balcony', value: 'BALCONY' },
            { key: 'tv', value: 'TV' },
            { key: 'monumentView', value: 'MONUMENT_VIEW' },
            { key: 'oven', value: 'OVEN' },
            { key: 'stove', value: 'STOVE' },
            { key: 'queenBed', value: 'BED_QUEEN' },
            { key: 'parkingIncluded', value: constants_1.PARKING_FEATURE },
        ];
        const amenitiesTemp = {};
        amenitiesList.forEach(amenity => {
            amenitiesTemp[amenity.key] = !!features.find(f => f.feature === amenity.value);
        });
        return amenitiesTemp;
    }, []);
    const mountInstallations = (0, react_1.useCallback)((features) => {
        const installationsList = [
            { key: 'parking', value: constants_1.PARKING_FEATURE },
            { key: 'reception', value: 'RECEPTION_24_HOUR' },
            { key: 'pool', value: 'POOL' },
            { key: 'gym', value: 'GYM' },
            { key: 'washer', value: 'WASHER' },
        ];
        const installationsTemp = {};
        installationsList.forEach(install => {
            installationsTemp[install.key] = !!features.find(f => f.feature === install.value);
        });
        return installationsTemp;
    }, []);
    (0, react_1.useEffect)(() => {
        if (Object.keys(amenities).length === 0) {
            (0, data_repository_1.getRoom)(roomId)
                .then(response => {
                setAmenities(mountAmenitites(response.room.features));
                setInstallations(mountInstallations(response.room.features));
            })
                .catch(err => {
                // message.error('Ocorreu um erro ao carregar as comodidades.');
                console.error('Erro ', err);
            });
        }
    }, [roomId, amenities, mountAmenitites, mountInstallations]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        withHeader && (react_1.default.createElement(AmenitiesStyles_1.Title, null,
            "Su\u00EDte \u00A0",
            react_1.default.createElement("span", null, name))),
        react_1.default.createElement(AmenitiesStyles_1.ContainerWrapper, { style: { display: 'flex', flexDirection: 'column' } },
            react_1.default.createElement("div", { className: "group" },
                withHeader && react_1.default.createElement("span", null, "Comodidades"),
                react_1.default.createElement(AmenitiesStyles_1.ContainerItems, null,
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.wifi }),
                        react_1.default.createElement("span", null, "Wi-Fi")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.airConditioning }),
                        react_1.default.createElement("span", null, "Ar Condicionado")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.balcony }),
                        react_1.default.createElement("span", null, "Varanda")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.tv }),
                        react_1.default.createElement("span", null, "Smart TV")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.monumentView }),
                        react_1.default.createElement("span", null, "Vista")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.oven }),
                        react_1.default.createElement("span", null, "Forno")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.stove }),
                        react_1.default.createElement("span", null, "Cooktop")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: amenities.queenBed }),
                        react_1.default.createElement("span", null, "Cama Queen")),
                    react_1.default.createElement("div", { className: "item" },
                        react_1.default.createElement(VisualCheckbox_1.default, { active: installations === null || installations === void 0 ? void 0 : installations.parking }),
                        react_1.default.createElement("span", null, "Estacionamento")))))));
};
exports.default = Amenities;
